import React, { PropTypes } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import * as PageActions from "actions/PageActions";

class HideRight extends React.Component {
	render() {
		var { rightPane, toggleRightPane } = this.props;
		var d = rightPane ? "M 15 4 L 26 15 L 15 26" : "M 15 4 L 4 15 L 15 26";
		return (
			<div className="hideRight" onClick={toggleRightPane}>
				<svg height="30" width="30">
					<line x1="4" y1="15" x2="26" y2="15" stroke="black" strokeWidth="4" />
					<path d={d} stroke="black" strokeWidth="4" />
				</svg>
			</div>
		);
	}
}

HideRight.propTypes = {
	rightPane: PropTypes.bool.isRequired,
};

function mapDispatchToProps(dispatch) {
	return { toggleRightPane: bindActionCreators(PageActions.toggleRightPane, dispatch) };
}

export default connect(state => state, mapDispatchToProps)(HideRight);


// 					<path d="M 15 4 L 26 15 L 15 26" stroke="black" strokeWidth="4" />
// 					<path d="M 15 4 L 4 15 L 15 26" stroke="black" strokeWidth="4" />



/** WEBPACK FOOTER **
 ** ./src/scripts/components/misc/HideRight.jsx
 **/